export const urlsPages={
    login:'/login',
    listQuotes:'/list-quotes',
    listPolicies:'/list-policies',
    generadorPagina:'/generador/:producto/:pagina',
    invalidToken:'/invalid-token',
    forgotPassword:'/forgot-password',
    actualizarContrasenia:'/actualizar-contrasenia'

}